import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/plaid/{creatorId}/link-token']['POST'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const createLinkToken = async ({ creatorId }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/plaid/${creatorId}/link-token`);
  return response.data;
};

export default createLinkToken;
